<template lang="pug">
  .legend__group
    .legend__type
      .semibold.legend__name
        span Поиск потоков отходов
    .legend__small-group
      e-suggestion.search.geo__search(
        placeholder=" "
        :suggestionEndpoint="suggestionEndpoint"
        @selectItem="selectOnSearch"
        @clear="clearSearchResult"
        name="search"
        :model="fields"
        :useInnerSearch="false"
        :addInfo="true"
        :addBorder="true"
        nameKey="objectName"
      )
</template>

<script>
import * as L from 'leaflet'

import { map as mapEndpoints } from '@/api/api-endpoints'
import MapPopup from '@/utils/map/popup/MapPopup'
import { MARKER_ICON } from '@/config/map'

export default {
  name: 'map-search-fields',
  props: {
    map: {
      type: Object,
    },
    year: {
      type: Number,
    },
  },
  data() {
    return {
      showSearch: false,
      fields: { search: '' },
      searchLayer: null,
    }
  },
  methods: {
    suggestionEndpoint(ctx, q) {
      return mapEndpoints.objectsSearch(null, {
        query: { q, year: this.year, limit: 10 },
      })
    },
    async selectOnSearch($event) {
      this.fields.search = $event.objectName
      let threads = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: mapEndpoints.threads({
            query: { year: this.year, flows: true },
          }),
          fromCache: false,
        })
      ).data

      threads = this.$store.getters.readUrlEndpoint(
        mapEndpoints.threads(this.$route)
      ).data

      this.$bar.start()

      threads = threads.filter(
        (t) => t.start.id === $event.geoObjectId || t.end.id === $event.objectId
      )

      this.$store.commit('mutateEndpoint', {
        endpoint: mapEndpoints.threads(this.$route),
        response: { data: { data: threads } },
      })
      await this.searchArrow($event)
      this.$emit('refreshMap')
      this.$bar.finish()
    },

    async searchArrow(item) {
      if (this.searchLayer) {
        this.map.removeLayer(this.searchLayer)
      }
      this.searchLayer = L.layerGroup()
      const arrows = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: mapEndpoints.searchThreadByobject({
            query: {
              objectId: item.objectId,
              objectType: item.objectType,
              geoObjectId: item.geoObjectId,
            },
          }),
        })
      ).data.data
      arrows.forEach((arrow) => {
        const polyline = L.polyline(
          [
            [arrow.start.lat, arrow.start.lng],
            [arrow.end.lat, arrow.end.lng],
          ],
          {
            color: '#009933',
          }
        )
        polyline.addTo(this.searchLayer)
        if (arrow.start.type !== 'tko_object') {
          this.prepareMarker(arrow.start)
        }
        this.map.fitBounds(polyline.getBounds())
      })
      this.searchLayer.addTo(this.map)
    },
    prepareMarker(element) {
      const latLng = L.latLng(Number(element.lat), Number(element.lng))
      let endpointForMarkers = null
      let iconType = false

      if (element.type === 'garbage_source') {
        endpointForMarkers = mapEndpoints.sourceById(element.id)
      }
      if (element.type === 'msn') {
        endpointForMarkers = mapEndpoints.msnById(element.id)
      }

      const marker = L.marker(latLng, {
        icon: MARKER_ICON,
      })

      const popup = new MapPopup({
        id: element.id,
        layerConfig: { endpoint: endpointForMarkers },
        subLayerConfig: {
          iconType,
        },
        hasMore: false,
      })
      marker.bindPopup(popup)
      this.searchLayer.addLayer(marker)
    },
    async clearSearchResult() {
      this.$bar.start()
      if (this.searchLayer) {
        this.map.removeLayer(this.searchLayer)
      }
      const threads = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: mapEndpoints.threads({
            query: { year: this.year, flows: true },
          }),
        })
      ).data

      this.$store.commit('mutateEndpoint', {
        endpoint: mapEndpoints.threads(this.$route),
        response: { data: threads },
      })
      this.$emit('refreshMap')
      this.$bar.finish()
    },
  },
}
</script>

<style lang="scss">
.geo {
  &__search {
    .input {
      padding-left: 30px;
    }
  }
}
</style>
